module.exports = __webpack_public_path__ + "img/2.fde8b3e9.png";